<template>
  <div class="labels-day--content cursor-pointer">
    <div class="labels-day--actions text-center mrg-b-10">
      <div @click="showShowHidePopup" class="btn btn-sm btn-outline-info mrg-t-10">
        Показать/Скрыть сотрудников <sup>{{showNowStaffCount}} из {{staff.length}}</sup>
      </div>
      <div @click="createEnrollButton(datePhpToRus(jsObjectToPhp(showDate)))"  class="btn btn-sm btn-info mrg-t-10">
        <f-awesome icon="plus"></f-awesome> Запись
      </div>
    </div>
    <div class="labels-day--layout-container">
      <div v-if="showStaffArrowPrev" @click="prevStaff" class="staff-arrow-left">
        <f-awesome icon="arrow-circle-left"></f-awesome>
      </div>
      <div v-if="showStaffArrowNext" @click="nextStaff" class="staff-arrow-right">
        <f-awesome icon="arrow-circle-right"></f-awesome>
      </div>
      <div class="staff-columns" v-if="lines.length">
        <div
          class="staff-item"
          v-for="(staff, index) in dataComputed"
          :key="index"
          :style="{height: linesHeight +'px'}"
        >
          <div class="staff-card">
            <div
              v-if="staff.labels.result == 'ok'"
              class="btn-sm-circle btn-info"
              @click="createEnroll(staff.staff.id, datePhpToRus(jsObjectToPhp(showDate)))"
            >
              <f-awesome icon="plus"></f-awesome>
            </div>
            <div class="avatar">
              <img :src="staff.staff.avatar">
            </div>
            <div class="info">
              <div class="name">{{getStaffName(staff.staff.name)}}</div>
              <div class="schedule">
                <span v-if="staff.labels.result == 'error'">
                  {{staff.labels.text}}
                </span>
                <span v-if="staff.labels.result == 'ok'">
                  График: {{minuteToTime(staff.labels.schedule.time_from)}} -
                  {{minuteToTime(staff.labels.schedule.time_to)}}
                </span>
              </div>
            </div>
          </div>

          <div v-if="staff.labels.result == 'ok'">
            <div
              class="enroll"
              v-for="(enroll, index) in staff.labels.response"
              :key="index"
            >
              <div
                :style="{
                  top: getCoordsTop(enroll) +'px',
                  height: getItemHeight(enroll) +'px',
                  left: getCoordsLeft(enroll) +'px',
                  width: getCoordsWidth(enroll) +'px'
                }"
                v-if="enroll.type == 'enroll'"
                class="enroll-label"
                :id="'enroll_id_' +enroll.id"
                :class="{
                  'status-new-transparent': enroll.confirm == 0,
                  'status-confirm-transparent': enroll.confirm == 1,
                  'status-done-transparent': enroll.confirm == 2,
                  'status-canceled-transparent': enroll.confirm == 3,
                }"
                @click="updateEnroll(enroll.id, enroll.time_from, enroll.staff_id, datePhpToRus(enroll.date))"
              >
                <div

                  class="enroll-data"
                >
                  <div class="time">
                  <span><b>{{minuteToTime(enroll.time_from)}} - {{minuteToTime(enroll.time_to)}}</b></span>
                  </div>
                  <div class="more">
                    <div v-if="+enroll.is_group === 0" class="client_name">
                      <span v-if="enroll.enrollClients[0].clientModification">
                        {{ enroll.enrollClients[0].clientModification.name }}
                      </span>
                      <span v-if="!enroll.enrollClients[0].clientModification">
                        {{ enroll.enrollClients[0].clients.name }} {{ enroll.enrollClients[0].clients.surname }}
                      </span>
                      <span v-if="enroll.enrollClients[0].clients.sale">(скидка {{enroll.enrollClients[0].clients.sale}}%) </span>
                      <span v-if="+enroll.enrollClients[0].clients.is_unwanted === 1"><b>(нежелательный клиент!)</b></span>
                    </div>
                    <div v-if="+enroll.is_group === 1" class="client_name">
                      <span class="text-bold">{{ calculateActiveGroupCount(enroll.enrollClients) }}</span> клиента (-ов) в групповой записи
                    </div>
                    <div v-if="+enroll.is_group === 0" class="client_number">{{  phoneNumberToMask(enroll.enrollClients[0].clients.number) }}</div>
                    <div class="client_services">
                      <span v-for="service in enroll.enrollPosition" :key="service.id"
                        >{{ service.service_name }}:
                      </span>
                    </div>
                    <div v-if="+enroll.is_group === 0 && enroll.enrollClients && enroll.enrollClients[0].comment && +enroll.is_group === 0" class="client_comment mrg-t-5">
                      Комментарий клиента: {{enroll.enrollClients[0].comment?enroll.enrollClients[0].comment:'-'}}
                    </div>
                    <div v-if="enroll.comments && enroll.comments.comment_company" class="company_comment mrg-t-5">
                      Ваш комментарий: {{enroll.comments?enroll.comments.comment_company:'-'}}
                    </div>
                  </div>
                </div>
                <div
                  @mouseenter="mouseEnter('enroll_id_' +enroll.id, enroll)"
                  @mouseleave="mouseLeave('enroll_id_' +enroll.id, enroll)"
                  v-show="getItemHeight(enroll) < 100"
                  class="show-full-enroll"
                >
                  <f-awesome icon="eye"></f-awesome>
                </div>
              </div>
              <div
                :style="{
                  top: getCoordsTop(enroll) +'px',
                  height: getItemHeight(enroll) +'px',
                  left: getCoordsLeft(enroll) +'px',
                  width: getCoordsWidth(enroll) +'px'
                }"
                v-if="enroll.type == 'break'"
                class="enroll-label label-break label-break-transparent"
              >
              <div class="enroll-data">
                <div class="time">
                  <span><b>{{minuteToTime(enroll.time_from)}} - {{minuteToTime(enroll.time_to)}}</b></span>
                </div>
                <div class="more">
                  перерыв
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layout-line" v-for="(line, index) in lines" :key="index">
        <div class="left-time" :class="{'bold': line.size == 'big', 'now-line': line.nowLine}">
          <span v-if="line.show">{{line.timeNormalize}}</span>
        </div>
        <div
          class="line"
          :class="{'show': line.show, 'big': line.size == 'big', 'small': line.size == 'small', 'now-line': line.nowLine}"
        ></div>
        <div class="right-time" :class="{'bold': line.size == 'big', 'now-line': line.nowLine}">
          <span v-if="line.show">{{line.timeNormalize}}</span>
        </div>
      </div>
    </div>

    <div
      class="labels-day--staff-bar-fixed"
      :style="{
        width: layoutContainerWidth +'px',
        left: layoutContainerLeft +'px',
        display: displayStaffBar
      }"
    >
      <div v-if="showStaffArrowPrev" @click="prevStaff" class="arrow-left">
        <f-awesome icon="arrow-circle-left"></f-awesome>
      </div>
      <div v-if="showStaffArrowNext" @click="nextStaff" class="arrow-right">
        <f-awesome icon="arrow-circle-right"></f-awesome>
      </div>
      <div class="staff-columns">
        <div
          class="staff-item"
          v-for="(staff, index) in dataComputed"
          :key="index"
        >
          <div class="staff-card">
            <div
              v-if="staff.labels.result == 'ok'"
              class="btn-sm-circle btn-info"
              @click="createEnroll(staff.staff.id, datePhpToRus(jsObjectToPhp(showDate)))"
            >
              <f-awesome icon="plus"></f-awesome>
            </div>
            <div class="avatar">
              <img :src="staff.staff.avatar">
            </div>
            <div class="info">
              <div class="name">{{getStaffName(staff.staff.name)}}</div>
              <div class="schedule">
                <span v-if="staff.labels.result == 'error'">
                  {{staff.labels.text}}
                </span>
                <span v-if="staff.labels.result == 'ok'">
                  {{minuteToTime(staff.labels.schedule.time_from)}} -
                  {{minuteToTime(staff.labels.schedule.time_to)}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <popup
      :closeButton="showHidePopup.closeButton"
      :show="showHidePopup.show"
      :dontHideOverflow="true"
      @closePopup="closeShowHidePopup"
    >
      <div slot="header">Отобразить/Скрыть сотрудников</div>
      <div slot="body">
        <div class="table--container">
          <div class="table--header center">
            <div class="name">Сотрудник</div>
            <div class="action">Действие</div>
          </div>
          <div class="table--rows">
            <div class="table--row center" v-for="item in showHideStaffData" :key="item.id">
              <div class="name">
                <div>{{item.name}}</div>
                <div class="text-hint">
                  <span v-if="!item.show">Скрыт</span>
                  <span v-if="item.show">Отображается</span>
                </div>
              </div>
              <div class="action">
                <div @click="toggleShowHide(item.id)" v-if="!item.show" class="btn btn-sm btn-success">Показать</div>
                <div @click="toggleShowHide(item.id)" v-if="item.show" class="btn btn-sm btn-orange">Скрыть</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </popup>


    <popup
      :closeButton="editEnrollPopup.closeButton"
      :show="editEnrollPopup.show"
      :size="editEnrollPopup.size"
      :backgroundColor="editEnrollPopup.backgroundColor"
      @closePopup="closeEditEnrollPopup"
    >
      <div slot="header">
        {{ editEnrollPopup.header }}
        <hints :type="'text'" :title="'Скидка клиента'">
          <div slot="text">
            Скидка будет автоматически применяться к стоимости каждой позиции.<br><br>
            <span class="text-orange">Внимание!</span> Если, создавая запись, вы сами подкорректировали стоимость
            какой-либо услуги, то к этим позициям скидка применяться не будет<br><br>
            Скидка применяется только в том случае, если на момент создания или редактирования записи стоимость
            позиции соответствует полной стоимости
          </div>
        </hints>
      </div>
      <div slot="body">
        <fast-new
          :show="editEnrollPopup.show"
          :staffId="selectedStaffId"
          :default-date="fastNewDefaultDate"
          :want-time="wantTime"
          :loadEnrollId="selectedEnrollId"
          :mode="fastNewMode"
          @updateLoadEnroll="updateLoadEnroll"
          @updateWantTime="updateWantTime"
          @closeAndUpdate="closeAndUpdateFast"
          @close="closeEditEnrollPopup"
        ></fast-new>
      </div>
    </popup>


  </div>
</template>

<script>


import Formatter from "../../libraries/Formatter";
import Popup from '../../Popup.vue';
import FastNew from './fast_new/FastNew.vue';
import Hints from '../../Hints.vue';

const formatter = new Formatter();

export default {
  name: "LabelsDay",
  components: {Popup, FastNew, Hints},
  data() {
    return {
      nowDate: new Date(),
      weekdayName: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
      weekdayNumber: [6, 0, 1, 2, 3, 4, 5],
      dateFrom: null,
      dateTo: null,
      calendar: [],
      fastNewDefaultDate: '1.1.1970',
      wantTime: 0,
      selectedEnrollId: null,
      fastNewMode: "new",
      selectedStaffId: 0,

      editEnrollPopup: {
        show: false,
        closeButton: 'Закрыть',
        size: "lg",
        header: "",
        backgroundColor: 'wgray'
      },

      showHidePopup: {
        show: false,
        closeButton: "Закрыть"
      },
      hidedStaffIds: [],
      clientWidth: 0,
      layoutContainerWidth: 0,
      layoutContainerLeft: 0,
      displayStaffBar: 'none',
      showStaffInPage: 0,
      showDataIdxNow: [],
      nowLineInterval: false,
      nowMinutes: 0,
    };
  },
  props: {
    data: Array,
    showDate: Date,
    staff: Array
  },
  watch: {
    hidedStaffIds: function(val){
      this.$emit('updateHideStaff', val);
    }
  },
  computed: {
    showNowStaffCount(){
      return this.staff.length - this.hidedStaffIds.length;
    },
    showHideStaffData(){
      let result = [];
      for(let key in this.staff){
        let show = true;
        for(let hidedKey in this.hidedStaffIds){
          if(+this.hidedStaffIds[hidedKey] === +this.staff[key].id){
            show = false;
          }
        }
        result[result.length] = {
          id: this.staff[key].id,
          name: this.staff[key].name,
          show: show
        };
      }
      return result;
    },
    dataComputed(){
      if(this.data.length <= this.showStaffInPage){
        return this.data;
      }else{
        let result = [];
        for(let key in this.showDataIdxNow){
          result[result.length] = this.data[this.showDataIdxNow[key]];
        }
        return result;
      }
    },
    linesHeight(){
      return this.lines.length * 10 +60;
    },
    minimalTime(){
      let minimalTime = false;
      if(this.dataComputed.length > 0){
        for(let key in this.dataComputed){
          if(this.dataComputed[key].labels.result == 'ok' && +this.dataComputed[key].labels.schedule.weekend === 0){
            if(minimalTime === false){
              minimalTime = this.dataComputed[key].labels.schedule.time_from;
            }else if(minimalTime > this.dataComputed[key].labels.schedule.time_from){
              minimalTime = this.dataComputed[key].labels.schedule.time_from;
            }
          }
        }
      }
      if(minimalTime === false){
        minimalTime = 0;
      }
      return minimalTime;
    },
    maximumTime(){
      let maximumTime = false;
      if(this.dataComputed.length > 0){
        for(let key in this.dataComputed){
          if(this.dataComputed[key].labels.result == 'ok' && +this.dataComputed[key].labels.schedule.weekend === 0){
            if(maximumTime === false){
              maximumTime = this.dataComputed[key].labels.schedule.time_to;
            }else if(maximumTime < this.dataComputed[key].labels.schedule.time_to){
              maximumTime = this.dataComputed[key].labels.schedule.time_to;
            }
          }
        }
      }
      if(maximumTime === false){
        maximumTime = 1440;
      }
      return maximumTime;
    },
    lines(){
      let nowDate = new Date();
      let minutes = this.nowMinutes;
      let result = [];

      if(this.dataComputed.length > 0){
        for(let i = this.minimalTime; i <= this.maximumTime; i = i + 5){
          let line = {time: i, timeNormalize: this.minuteToTime(i)};

          if(
            formatter.isIdenticalDates(formatter.jsObjectToPhp(this.showDate), formatter.jsObjectToPhp(nowDate)) &&
            (
              (minutes % 5 === 0 && minutes == i) ||
              (minutes % 5 > 0 && minutes - (minutes % 5) == i )
            )
          ){
            line.nowLine = true;
          }else{
            line.nowLine = false;
          }

          if(i % 60 === 0){
            line.show = true;
            line.size = 'big';
          }else if(i % 60 === 15 || i % 60 === 30 || i % 60 === 45){
            line.show = true;
            line.size = 'small';
          }else{
            line.show = false;
          }
          result[result.length] = line;
        }

      }

      return result;
    },
    showStaffArrowNext(){
      let maxShowIdxNow = 0;
      for(let key in this.showDataIdxNow){
        if(this.showDataIdxNow[key] > maxShowIdxNow){
          maxShowIdxNow = this.showDataIdxNow[key];
        }
      }
      if(maxShowIdxNow < this.data.length - 1){
        return true;
      }else{
        return false;
      }
    },
    showStaffArrowPrev(){
      let minShowIdxNow = 9999999;
      for(let key in this.showDataIdxNow){
        if(this.showDataIdxNow[key] < minShowIdxNow){
          minShowIdxNow = this.showDataIdxNow[key];
        }
      }

      if(minShowIdxNow > 0){
        return true;
      }else{
        return false;
      }
    }
  },
  methods: {
    calculateActiveGroupCount(data){
      let result = 0;
      for(let key in data){
        if(+data[key].is_canceled === 0){
            if(data[key].clients){
              result++;
            }
          }
      }
      return result;
    },
    mouseEnter(itemId, enroll){
      if(this.getItemHeight(enroll) < 100){
        document.getElementById(itemId).style.height = '200px';
        document.getElementById(itemId).style.zIndex = '1';
      }
    },
    mouseLeave(itemId, enroll){
      if(this.getItemHeight(enroll) < 100){
        document.getElementById(itemId).style.height = this.getItemHeight(enroll) +'px';
        document.getElementById(itemId).style.zIndex = '0';
      }
    },
    createEnrollButton(date) {
      this.fastNewMode = "new";
      this.selectedEnrollId = 0; // Сбросим
      this.editEnrollPopup.show = true;
      this.editEnrollPopup.header = "Добавление записи";
      this.fastNewDefaultDate = date;
    },
    createEnroll(staffId, date) {
      this.fastNewMode = "new";
      this.selectedEnrollId = 0; // Сбросим
      this.editEnrollPopup.show = true;
      this.editEnrollPopup.header = "Добавление записи";
      this.selectedStaffId = +staffId;
      this.fastNewDefaultDate = date;
    },
    updateEnroll(id, wantTime, staffId, date) {
      this.fastNewMode = "edit";
      this.editEnrollPopup.show = true;
      this.selectedEnrollId = +id;
      this.wantTime = wantTime;
      this.editEnrollPopup.header = "Изменение записи";
      this.selectedStaffId = +staffId;
      this.fastNewDefaultDate = date;
    },
    closeEditEnrollPopup() {
      this.editEnrollPopup.show = false;
    },
    toggleShowHide(staffId){
      let existsHide = false;
      for(let key in this.hidedStaffIds){
        if(+this.hidedStaffIds[key] === +staffId){
          this.hidedStaffIds.splice(key, 1);
          existsHide = true;
        }
      }
      if(!existsHide){
        if(this.hidedStaffIds.length === (this.staff.length - 1)){
          this.$store.dispatch("addNotification", {
            text: 'Нельзя скрыть всех сотрудников',
            time: 3,
            color: "danger"
          });
          return false;
        }

        this.$set(this.hidedStaffIds, this.hidedStaffIds.length, staffId);
      }
    },
    showShowHidePopup(){
      this.showHidePopup.show = true;
    },
    closeShowHidePopup(){
      this.showHidePopup.show = false;
    },
    prevStaff(){
      let minShowIdxNow = 9999999;
      for(let key in this.showDataIdxNow){
        if(this.showDataIdxNow[key] < minShowIdxNow){
          minShowIdxNow = this.showDataIdxNow[key];
        }
      }

      if(minShowIdxNow > 0){
        if(minShowIdxNow - this.showStaffInPage >= 0){
          let newShowDataIdxNow = [];
          for(
            let i = minShowIdxNow - this.showStaffInPage;
            i <= (minShowIdxNow - this.showStaffInPage) + (this.showStaffInPage -1);
            i++
          ){
            newShowDataIdxNow[newShowDataIdxNow.length] = i;
          }
          this.showDataIdxNow = newShowDataIdxNow;
        }else{
          let newShowDataIdxNow = [];
          for(
            let i = 0;
            i <= this.showStaffInPage -1;
            i++
          ){
            newShowDataIdxNow[newShowDataIdxNow.length] = i;
          }
          this.showDataIdxNow = newShowDataIdxNow;
        }
      }
    },
    nextStaff(){
      let maxShowIdxNow = 0;
      for(let key in this.showDataIdxNow){
        if(this.showDataIdxNow[key] > maxShowIdxNow){
          maxShowIdxNow = this.showDataIdxNow[key];
        }
      }
      if(maxShowIdxNow < this.data.length - 1){
        if((maxShowIdxNow + this.showStaffInPage) > this.data.length - 1){
          let newShowDataIdxNow = [];
          for(
            let i = (this.data.length) - this.showStaffInPage;
            i <= this.data.length - 1;
            i++
          ){
            newShowDataIdxNow[newShowDataIdxNow.length] = i;
          }
          this.showDataIdxNow = newShowDataIdxNow;
        }else{
          let newShowDataIdxNow = [];
          for(
            let i = maxShowIdxNow +1;
            i <= maxShowIdxNow + this.showStaffInPage;
            i++
          ){
            newShowDataIdxNow[newShowDataIdxNow.length] = i;
          }
          this.showDataIdxNow = newShowDataIdxNow;
        }
      }
    },
    getCoordsTop(item){
      for(let i = 0; i < this.lines.length; i++){
        if( this.lines[i].time == item.time_from){
          return i *10 +1;
        }
      }
    },
    getCoordsLeft(item){
      let staffWidth = document.getElementsByClassName('staff-item')[0].clientWidth;
      let margin = 5;
      if(item.existsIntersect){
        let itemWidth = ( staffWidth - (margin * (item.intersectCount +1)) ) / item.intersectCount;
        return itemWidth * (item.intersectIndex - 1) + margin *item.intersectIndex;
      }else{
        return margin;
      }
    },
    getCoordsWidth(item){
      let staffWidth = document.getElementsByClassName('staff-item')[0].clientWidth;
      let margin = 5;
      if(item.existsIntersect){
        return ( staffWidth - (margin * (item.intersectCount +1)) ) / item.intersectCount;
      }else{
        return staffWidth - (margin *2);
      }
    },
    getItemHeight(item){
      let bottom = 0;
      for(let i = 0; i < this.lines.length; i++){
        if( this.lines[i].time == item.time_to){
          bottom = i *10 - 1;
        }
      }
      return bottom - this.getCoordsTop(item);
    },
    phoneNumberToMask(number){
      return formatter.phoneNumberToMask(number);
    },
    minuteToTime(minutes) {
      return formatter.minuteToTime(minutes);
    },
    getStaffName(staffName){
      if(staffName.length > 15){
        return staffName.slice(0, 15) +'...';
      }else{
        return staffName.slice(0, 15);
      }
    },
    datePhpToRus(val){
      return formatter.phpDateToRus(val);
    },
    jsObjectToPhp(jsObject){
      return formatter.jsObjectToPhp(jsObject);
    },
    resizePage(){
      let width = window.innerWidth;
      let layoutContainerWidth = document.getElementsByClassName('labels-day--layout-container')[0].clientWidth;

      let layoutContainerRect = document.getElementsByClassName('labels-day--layout-container')[0].getBoundingClientRect();

      if(layoutContainerRect.left != this.layoutContainerLeft){
        this.layoutContainerLeft = layoutContainerRect.left;
      }

      if(this.layoutContainerWidth != layoutContainerWidth){
        this.layoutContainerWidth = layoutContainerWidth;
      }
      if(this.clientWidth != width){
        this.clientWidth = width;
        if(width > 2300){
          this.showStaffInPage = 10;
          this.showDataIdxNow = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        }else if(width <= 2300 && width > 1919){
          this.showStaffInPage = 7;
          this.showDataIdxNow = [0, 1, 2, 3, 4, 5, 6];
        }else if(width <= 1919 && width > 1300){
          this.showStaffInPage = 5;
          this.showDataIdxNow = [0, 1, 2, 3, 4];
        }else if(width <= 1300 && width > 1150){
          this.showStaffInPage = 4;
          this.showDataIdxNow = [0, 1, 2, 3];
        }else if(width <= 1150 && width > 700){
          this.showStaffInPage = 3;
          this.showDataIdxNow = [0, 1, 2];
        }else if(width <= 700 && width > 500){
          this.showStaffInPage = 2;
          this.showDataIdxNow = [0, 1];
        }else if(width <= 500){
          this.showStaffInPage = 1;
          this.showDataIdxNow = [0];
        }
      }
    },
    scrollStaffBar(){
      let layoutContainer = document.getElementsByClassName('labels-day--layout-container');
      if(layoutContainer.length){
        let layoutContainerCoords = layoutContainer[0].getBoundingClientRect();
        let layoutTop = (layoutContainerCoords.top + window.pageYOffset);

        let scroll = document.body.scrollTop || document.documentElement.scrollTop;

        if(scroll > layoutTop){
          this.resizePage();
          this.displayStaffBar = 'block';
        }else{
          this.displayStaffBar = 'none';
        }
      }
    },
    setNowMinutes(){
      let nowDate = new Date();
      this.nowMinutes = formatter.hourMinuteToMinute(
        nowDate.getHours(),
        nowDate.getMinutes()
      );
    },
    closeAndUpdateFast() {
      this.closeEditEnrollPopup();
    },
    updateLoadEnroll(val) {
      this.selectedEnrollId = val;
      this.fastNewMode = "edit";
    },
    updateWantTime(val) {
      this.wantTime = val;
    },
  },
  created() {

  },
  mounted() {
    this.resizePage();
    window.addEventListener('resize', this.resizePage);
    window.addEventListener('scroll', this.scrollStaffBar);
    this.nowLineInterval = setInterval(this.setNowMinutes, 10000);
    this.setNowMinutes();
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.resizePage);
    window.removeEventListener('scroll', this.scrollStaffBar);
    clearInterval(this.nowLineInterval);
  }
};
</script>

<style scoped lang="less">
.labels-day--content{
  width: 100%;
}

.labels-day--staff-bar-fixed{
  background-color: #fff;
  position: fixed;
  height: 69px;
  top: 45px;

  .arrow-left{
    width: 50px;
    height: 60px;
    line-height: 50px;
    color: gray;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    font-size: 24px;
  }
  .arrow-right{
    width: 50px;
    height: 60px;
    line-height: 50px;
    color: gray;
    text-align: center;
    position: absolute;
    top: 0;
    right: 0;
    font-size: 24px;
  }

  .staff-columns{
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    flex-direction: row;
    position: absolute;
    top: 0;
    left: 50px;
    right: 50px;

    .staff-item{
      width: 100%;

      .staff-card{
        box-shadow: 3px 3px 6px 0px rgba(0, 0, 0, 0.15);
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        flex-direction: row;
        background-color: #fff;
        padding: 5px 0;
        position: relative;

        .btn-sm-circle{
          position: absolute;
          right: 2px;
          top: 2px;
        }

        .avatar{
          width: 70px;
          text-align: center;
          img{
            width: 45px;
          }
        }
        .info{
          width: 95%;

          .schedule{
            margin-top: 5px;
            font-size: 12px;
            color: gray;
          }
        }
      }
    }
  }
}
.labels-day--layout-container{
  padding-top: 60px;
  width: 100%;
  position: relative;

  .staff-arrow-left{
    width: 50px;
    height: 60px;
    line-height: 50px;
    color: gray;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    font-size: 24px;
  }
  .staff-arrow-right{
    width: 50px;
    height: 60px;
    line-height: 50px;
    color: gray;
    text-align: center;
    position: absolute;
    top: 0;
    right: 0;
    font-size: 24px;
  }

  .staff-columns{
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    flex-direction: row;
    position: absolute;
    top: 0;
    left: 50px;
    right: 50px;


    .staff-item{
      width: 100%;
      border-right: 1px solid rgb(228, 228, 228);
      border-left: 1px solid rgb(228, 228, 228);

      .staff-card{
        box-shadow: 3px 3px 6px 0px rgba(0, 0, 0, 0.15);
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        flex-direction: row;
        background-color: #fff;
        padding: 5px 0;
        position: relative;

        .btn-sm-circle{
          position: absolute;
          right: 2px;
          top: 2px;
        }

        .avatar{
          width: 70px;
          text-align: center;
          img{
            width: 45px;
          }
        }
        .info{
          width: 95%;

          .schedule{
            margin-top: 5px;
            font-size: 12px;
            color: gray;
          }
        }
      }

      .enroll{
        width: 100%;
        position: relative;
        margin: 0 auto;

        &>.enroll-label{
          position: absolute;
          width: inherit;
          border-radius: 10px;

          &>.enroll-data{
            position: absolute;
            top: 6px;
            right: 7px;
            bottom: 6px;
            left: 7px;
            margin: auto;
            overflow: hidden;
            .time{
              font-size: 12px;
            }
            .more{
              font-size: 13px;
            }
          }

          &>.show-full-enroll{
            width: 20px;
            height: 18px;
            position: absolute;
            right: 4px;
            top: 0;

            svg{
              color: gray;
            }
          }
        }
      }
    }
  }

  .layout-line{
    height: 10px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    flex-direction: row;
    .left-time{
      text-align: center;
      width: 50px;
      line-height: 2px;
      font-size: 13px;

      &.bold{
        font-weight: 700;
        font-size: 15px;
      }
      &.now-line{
        color: #F97979;
      }
    }
    .right-time{
      text-align: center;
      width: 50px;
      line-height: 2px;
      font-size: 13px;

      &.bold{
        font-weight: 700;
        font-size: 15px;
      }
      &.now-line{
        color: #F97979;
      }
    }
    .line{
      width: 100%;
      box-sizing: border-box;

      &.show.big{
        border-top: 2px solid rgb(228, 228, 228);
      }
      &.show.small{
        border-top: 1px solid rgb(228, 228, 228);
      }
      &.now-line{
        position: relative;
        border-top: 1px solid #F97979 !important;
      }
    }
  }
}
.labels-day--last-update{
  margin-top: 10px;
  margin-bottom: 8px;
    .text{
      font-size: 12px;
      color: gray;
    }
    .hint{
      margin-left: 5px;
    }
}
</style>
